function youtubeVideoId(videoUrl) {
  const url = String(videoUrl || '');
  if (!url) return '';

  if (url.slice(0, 7) === '<iframe') {
    const source = url.match(/src=["']([^"']+)["']/i);
    const src = source ? source[1] : '';
    const embed = src.match(/(?:youtube\.com|youtube-nocookie\.com)\/embed\/([\w-]{6,})/);
    return embed ? embed[1] : '';
  }

  if (url.includes('youtu.be/')) {
    const path = url.split('youtu.be/')[1] || '';
    return path.split(/[?&#]/)[0];
  }

  if (url.includes('youtube.com')) {
    try {
      return new URL(url).searchParams.get('v') || '';
    } catch (e) {
      return '';
    }
  }

  return '';
}

export default function youtubeEmbedUrl(videoUrl) {
  const id = youtubeVideoId(videoUrl);
  if (!/^[\w-]{6,}$/.test(id)) return '';
  const encoded = encodeURIComponent(id);
  return `https://www.youtube.com/embed/${encoded}?autoplay=0&controls=1&loop=1&rel=0&modestbranding=0&playlist=${encoded}`;
}
